import * as React from 'react';
export const SocialBarContext = React.createContext(null);
export const SocialBarProvider = SocialBarContext.Provider;
export const useSocialBarContext = () => React.useContext(SocialBarContext);
//# sourceMappingURL=SocialBarContext.js.map